import React from 'react';
/* eslint-disable */
export function DotsHorizontalOutlined(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="transparent" />
      <path
        d="M18.9375 14.75C18.9375 15.4883 19.5117 16.0625 20.25 16.0625C20.9609 16.0625 21.5625 15.4883 21.5625 14.75C21.5625 14.0391 20.9609 13.4375 20.25 13.4375C19.5117 13.4375 18.9375 14.0391 18.9375 14.75ZM11.0625 14.75C11.0625 14.0391 10.4609 13.4375 9.75 13.4375C9.01172 13.4375 8.4375 14.0391 8.4375 14.75C8.4375 15.4883 9.01172 16.0625 9.75 16.0625C10.4609 16.0625 11.0625 15.4883 11.0625 14.75ZM16.3125 14.75C16.3125 14.0391 15.7109 13.4375 15 13.4375C14.2617 13.4375 13.6875 14.0391 13.6875 14.75C13.6875 15.4883 14.2617 16.0625 15 16.0625C15.7109 16.0625 16.3125 15.4883 16.3125 14.75Z"
        fill="#828299"
      />
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="currentColor" />
    </svg>
  );
}
